import axios from 'axios';

const instance = axios.create();

// Global error notification function
let globalEnqueueSnackbar = null;

// Function to set global snackbar (called from App component)
export const setGlobalSnackbar = (enqueueSnackbar) => {
  globalEnqueueSnackbar = enqueueSnackbar;
};

// Response interceptor for automatic error notifications
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only show notifications if we have the global snackbar function
    // and the request doesn't explicitly disable notifications
    const showNotification = error.config?.showErrorNoty !== false;
    
    if (globalEnqueueSnackbar && showNotification && error.response) {
      const { data, status } = error.response;
      
      // Only show for client and server errors (4xx, 5xx)
      if (status >= 400) {
        let errorMessage = 'Something went wrong...';
        
        // Handle different error response formats
        if (data?.errors?.length) {
          // Multiple errors - show each one
          data.errors.forEach((err) => {
            globalEnqueueSnackbar(err || errorMessage, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
              autoHideDuration: 4000,
            });
          });
          return Promise.reject(error);
        } else if (data?.error) {
          errorMessage = data.error;
        } else if (data?.message) {
          errorMessage = data.message;
        } else if (typeof data === 'string') {
          errorMessage = data;
        }
        
        globalEnqueueSnackbar(errorMessage, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          autoHideDuration: 4000,
        });
      }
    }
    
    return Promise.reject(error);
  }
);

export default instance;
